import { render } from "./icon-coins.vue?vue&type=template&id=5a80fb35"
const script = {}

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__